<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">入库药品选择</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <div>
                    <el-row style="float: left;margin:10px 0">
                        <el-input  placeholder="请输入药品名称" v-model="name" clearable style="width:200px"></el-input>
                        <el-select v-model="warehouseDrugCode" placeholder="请选择仓库" clearable style="margin:0 5px;width:200px;">
                            <el-option
                                    v-for="item in warehouseDrugCodeValue"
                                    :key="item.warehouseDrugCode"
                                    :label="item.name"
                                    :value="item.warehouseDrugCode">
                            </el-option>
                        </el-select>
                        <el-select v-model="supplierDrugCode" placeholder="请选择供应商" clearable style="margin:0 5px;width:200px;">
                            <el-option
                                    v-for="item in SupplierDrugCodeValue"
                                    :key="item.supplierDrugCode"
                                    :label="item.name"
                                    :value="item.supplierDrugCode">
                            </el-option>
                        </el-select>
                        <el-select v-model="waresTypeDrugCode" placeholder="请选择药品类型" clearable style="margin:0 5px;width:200px;">
                            <el-option
                                    v-for="item in WaresTypeDrugCodeValue"
                                    :key="item.waresTypeDrugCode"
                                    :label="item.name"
                                    :value="item.waresTypeDrugCode">
                            </el-option>
                        </el-select>
                        <el-select v-model="status" placeholder="选择药品状态" style="margin:0 5px;width:200px;">
                            <el-option
                                    v-for="item in status2"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                        <el-button style="margin-left:10px" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </el-row>
                    <div style="clear: both;"></div>
                </div>
                 <template>
                <el-table :data="tableData" height="500" border v-loading="loading">

                    <el-table-column prop="name" label="药品名称"></el-table-column>

                    <el-table-column prop="supplierDrugName" label="供应商"></el-table-column>

                    <el-table-column prop="waresTypeDrugName" label="药品类型"></el-table-column>

                    <el-table-column prop="stock" label="库存"></el-table-column>

                    <el-table-column
                            prop="Status"
                            :formatter="statusTitle"
                            label="状态">
                    </el-table-column>

                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="primary" v-if="scope.row.add==0" size="small" @click="handleSelect(scope.$index, scope.row)">选择</el-button>
                            <el-button type="success" v-if="scope.row.add==1" size="small">已添加</el-button>
                        </template>
                    </el-table-column>

                </el-table>
                <div style="text-align: left;background-color: #fff;padding: 10px;">
                    <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                    <div style="float: left;">
                        <el-pagination
                                background
                                layout="prev, pager, next"
                                :total="totalItems"
                                :page-size="20"
                                @current-change="current_change">
                        </el-pagination>
                    </div>
                    <div style="clear: both;"></div>
                </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode,getTokenBykey} from "@/utils/auth";

    export default {
        name: "Add",
        data() {
            return {

                loading: true,
                add_waresDrugCode:'',
                pageSize:20,
                currentPage:1,
                showModalAdd:false,
                tableData:[],
                waresDrugList:[],
                status:-1,
                totalItems: 0,
                th:0,
                SupplierDrugCodeValue:[],
                WaresTypeDrugCodeValue:[],
                warehouseDrugCodeValue:[],
                supplierDrugCode:'',
                waresTypeDrugCode:'',
                warehouseDrugCode:'',
                status2: [{
                    value: -1,
                    label: '所有状态'
                },{
                    value: 0,
                    label: '正常'
                }, {
                    value: 1,
                    label: '禁用'
                }],
                name:'',
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    name:'',
                    address:'',
                },

                rules:{
                    name:[
                        { required: true, message: '药品名称', trigger: 'blur' },
                    ],
                    sort:[
                        { required: true, message: '请输入库存', trigger: 'blur' },
                        { type: 'number', message: '库存必须为数字值'}
                    ],
                }


            }
        },

        methods: {
            init(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"WarehouseDrug/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.warehouseDrugCodeValue = response.data.data;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"SupplierDrug/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.SupplierDrugCodeValue = response.data.data;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"WaresTypeDrug/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.WaresTypeDrugCodeValue = response.data.data;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
                this.getList();
                // var list=getTokenBykey('waresDrugInfoAdd');
            },
            closeSelf() {
                this.$emit("closeSelectWaresDrug");
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },
            
            handleSelect(index,row){
                var list=getTokenBykey(getStaffCode()+'waresDrugInfoAdd');
                list?list=JSON.parse(list):list=[]
                if(this.isAdd(row.waresDrugCode,list)){
                    this.$prompt('请输入此药品入库数量', '商品数量', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputPattern:/^[1-9]\d*$/,
                        inputErrorMessage:'添加数量不能为零',
                        inputType:'number'
                    }).then(({ value }) => {
                        row.count=value
                        this.$emit("getWaresDrug",row);
                        this.tableData=this.getData(this.tableData)
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '取消输入'
                        });       
                    });
                }else{
                    this.$message({
                        type: 'info',
                        message: '此药品已添加'
                    }); 
                }
            },
            isAdd(code,list){
                for(var i in list){
                    if(list[i].waresDrugCode==code){
                        return false;
                    }
                }
                return true
            },
            changeWaresDrug(selVal){
                this.add_waresDrugCode=selVal;
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },
            getList(){
                this.loading=true;
                var supplierDrugCode=this.supplierDrugCode;
                var waresTypeDrugCode=this.waresTypeDrugCode;
                var warehouseDrugCode=this.warehouseDrugCode;
                if(!supplierDrugCode){
                    supplierDrugCode='00000000-0000-0000-0000-000000000000'
                }
                if(!waresTypeDrugCode){
                    waresTypeDrugCode='00000000-0000-0000-0000-000000000000'
                }
                if(!warehouseDrugCode){
                    warehouseDrugCode='00000000-0000-0000-0000-000000000000'
                }
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+'WaresDrug/Page',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        waresTypeDrugCode:waresTypeDrugCode,
                        supplierDrugCode:supplierDrugCode,
                        warehouseDrugCode:warehouseDrugCode,
                        name:this.name,
                        status:this.status,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then((response)=> {
                    this.loading=false;
                    if(response.data.error == 0){
                        var data= response.data.data.list;
                        this.tableData=this.getData(data)
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message(response.data.message);
                    }else{
                        console.log(response.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getData(data){
                var waresDrugInfoAdd=getTokenBykey(getStaffCode()+'waresDrugInfoAdd');
                for(var i in data){
                    if(waresDrugInfoAdd){
                        if(!this.isAdd(data[i].waresDrugCode,JSON.parse(waresDrugInfoAdd))){
                            data[i].add=1
                        }else{
                            data[i].add=0
                        }
                    }else{
                        data[i].add=0
                    }
                }
                console.log(data)
                return data
            }
        }
    }
</script>

<style  lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

    .modal {
        background-color: #fff;
        box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        overflow-x:auto;
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        width:1180px;

    .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: space-between;
        padding: 10px;
        display: flex;
    }
    .modal-body {
        position: relative;
        padding: 20px 20px 0;
        z-index: 99;
        height: 100%;
    }
    .modal-footer {
        border-top: 1px solid #eee;
        justify-content: flex-end;
        padding: 15px;
        display: flex;
    }


    }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }
</style>